import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Tabs, Skeleton } from 'antd';
import { useLocation, useNavigate } from 'react-router';

import { getSourceDetails } from 'api-services/data-source';
import ChatBotContext from 'hooks/chat-bot-context';
import useDecodeToken from 'hooks/use-decode-token';
import Document from './components/document';
import Spreadsheet from './components/spread-sheet';
// import AddText from './components/text';
import AddWebsite from './components/website';


const DataSource = () => {
  const navigate = useNavigate();
  const { dataSizeAllowed } = useDecodeToken();
  const { selectedBot } = useContext(ChatBotContext);
  const location = useLocation();
  const onEditMode = location.pathname === '/data-source';
  const [skeleton, setSkeleton] = useState(location.pathname === '/data-source');
  const [dataSource, setDataSource] = useState(null);
  const [sourceType, setSourceType] = useState('');

  useEffect(() => {
    const getDetails = async () => {
      setSkeleton(true);
      const response = await getSourceDetails(selectedBot);
      if (response.status === 200) {
        setDataSource(response.data);
        setSourceType(getSourceType(response.data.source_type));
      }
      setSkeleton(false);
    };

    if (selectedBot && onEditMode) {
      getDetails();
    } else {
      if(onEditMode) navigate('/chatbots');
    }
  }, [selectedBot]);

  const getSourceType = (source) => {
    switch (source) {
    case 'xlsx':
    case 'xls':
    case 'csv':
      return 'spreadsheet';

    case 'pdf':
    case 'docx':
    case 'doc':
    case 'txt':
    case 'multi':
      return 'document';

    case 'website':
      return 'website';

    default:
      return 'text';
    }
  };
  // const allowedDataSize = getAllowedDataSize(planId);
  
  const getDocumentTab =() => {
    return {
      label: 'Documents',
      key: 'document',
      children: <Document onEditMode={onEditMode} dataSource={dataSource} sourceType={sourceType} allowedDataSize={dataSizeAllowed} />,
    };
  };

  const getSpreadsheetTab = () => {
    return {
      label: 'Spreadsheets',
      key: 'spreadsheet',
      children: <Spreadsheet onEditMode={onEditMode} dataSource={dataSource} sourceType={sourceType} allowedDataSize={dataSizeAllowed}/>,
    };
  };

  const getWebsiteTab = () => {
    return {
      label: 'Website',
      key: 'website',
      children: <AddWebsite onEditMode={onEditMode} dataSource={dataSource} sourceType={sourceType} />,
    };
  };

  const getTabs = () => {
    const tabs = [];
    if(onEditMode) {
      switch(sourceType) {
      case 'document':
        tabs.push(getDocumentTab());
        break;
      case 'spreadsheet':
        tabs.push(getSpreadsheetTab());
        break;
      case 'website':
        tabs.push(getWebsiteTab());
        break;
      }
    } else {
      tabs.push(getDocumentTab());
      tabs.push(getSpreadsheetTab()); 
      tabs.push(getWebsiteTab()); 
    }
    return tabs;
  };

  return (
    <Row className='data-source-wrapper'>
      <Col span={18}>
        <h2>{onEditMode? 'Update your Chatbot': 'Start building your Chatbot'}</h2>
        {skeleton && <Skeleton active />}
        {!skeleton && <Tabs
          defaultActiveKey={sourceType}
          items={getTabs()}
        />}
      </Col>     
    </Row>
  );
};

export default DataSource;
